class MerchantList
{
    merchants = []
    visibleIds = []

    categoryFilter = []
    textFilter = {}

    mapHandler = null

    constructor(container) {
        this.container = container
        this.counterSpan = container.querySelector('span.counter')

        if (typeof this.counterSpan == 'undefined') {
            throw new Error('merchant list without counter span')
        }

        let searchContainer = this.container.previousSibling
        while (searchContainer && (searchContainer.nodeName === '#text' || !searchContainer.classList.contains('merchant-filters'))) {
            searchContainer = searchContainer.previousSibling
            if (!searchContainer) {
                break
            }
        }

        this.load()

        if (searchContainer) {
            this.initSearch(searchContainer)
        }
    }

    initSearch(searchContainer) {
        searchContainer.querySelectorAll('input').forEach(elem => {
            if (elem.hasAttribute('data-filter')) {
                const type = elem.getAttribute('data-filter')
                if (type === 'cat') {
                    const catId = parseInt(elem.getAttribute('data-id'))
                    if (elem.checked) {
                        this.categoryFilter.push(catId)
                    }
                    elem.addEventListener('change', () => {
                        const index = this.categoryFilter.indexOf(catId)
                        if (elem.checked) {
                            if (index < 0) {
                                this.categoryFilter.push(catId)
                            }
                        } else {
                            this.categoryFilter = this.categoryFilter.filter(id => id !== catId)
                        }
                        this.applyFilters()
                    })
                } else {
                    const fn = () => {
                        this.textFilter[type] = elem.value.trim()
                        this.applyFilters()
                    }
                    elem.addEventListener('keyup', fn)
                    elem.addEventListener('change', fn)
                }
            }
        })
    }

    applyFilters() {
        this.visibleIds = this.merchants
            .map(m => {
                let found = false
                for (const catId of this.categoryFilter) {
                    if (m.data.cats.includes(catId)) {
                        found = true
                        break
                    }
                }
                if (!found) {
                    return null
                }

                for (const key in this.textFilter) {
                    if (this.textFilter[key] && this.textFilter[key].length) {
                        const term = this.textFilter[key].toLowerCase()
                        switch (key) {
                            case 'name-zip':
                                if (m.data.name.toLowerCase().indexOf(term) < 0 && m.data.zip.toLowerCase().indexOf(term) < 0) {
                                    return null
                                }
                                break;
                            default:
                                if (m.data[key].toLowerCase().indexOf(term) < 0) {
                                    return null
                                }
                                break;
                        }
                    }
                }
                return m.data.id
            })
            .filter(id => id !== null)
        this.update()
    }

    load() {
        this.container.querySelectorAll('li').forEach(li => {
            const merchant = {
                elem: li,
                data: {}
            }
            for (const key of ['id', 'name', 'zip', 'state', 'city', 'cats']) {
                merchant.data[key] = li.getAttribute(`data-${key}`)
            }
            merchant.data.id = parseInt(merchant.data.id)
            merchant.data.cats = merchant.data.cats.split(',').filter(cat => !!cat).map(cat => parseInt(cat))

            this.merchants.push(merchant)
        })

        this.visibleIds = this.merchants.map(m => m.data.id)

        this.update()
    }

    getVisibleIds() {
        return this.merchants
            .filter(m => this.visibleIds.includes(m.data.id))
            .map(m => m.data.id)
    }

    update() {
        const ids = this.getVisibleIds()
        this.merchants.forEach(m => m.elem.style.display = ids.includes(m.data.id) ? 'flex' : 'none')

        this.counterSpan.innerHTML = `(${ids.length})`
    }

    hasMapHandler() {
        return this.mapHandler !== null
    }

    setMapHandler(handler) {
        console.log('got new map handler', this, handler)
        this.mapHandler = handler
    }
}

const lists = []
let map = null

const initMerchantLists = () => {
    document.querySelectorAll('.merchant-list').forEach(container => {
        const list = new MerchantList(container)
        if (map) {
            list.setMapHandler(new MapHandler(map))
        }
        lists.push(list)
    })
}

window.onMerchantMapCreated = (gmap) => {
    lists.map(l => {
        if (!l.hasMapHandler()) {
            l.setMapHandler(gmap)
        }
    })
    map = gmap
}

class MapHandler
{
    map = null

    constructor(map) {
        this.map = map
    }
}

export default initMerchantLists
